import { useOutletContext } from 'react-router-dom'
import type { AppInfo } from '@/types'

export interface AppOutletContext {
  app: AppInfo
}

/** 从 AppDetailLayout 的 Outlet context 中获取当前应用 */
export function useCurrentApp(): AppInfo {
  return useOutletContext<AppOutletContext>().app
}
